import { doAction, doResponseAction } from ".";

const QR_ACCESS_LIST = 'QR_ACCESS_LIST';
const QR_ACCESS_LIST_SUCCESS = 'QR_ACCESS_LIST_SUCCESS';
const QR_ACCESS_LIST_FAILURE = 'QR_ACCESS_LIST_FAILURE';

export {
    QR_ACCESS_LIST,
    QR_ACCESS_LIST_FAILURE,
    QR_ACCESS_LIST_SUCCESS,
}

export const qrAccessList = (params, callback) => doAction(QR_ACCESS_LIST, params, callback);
export const qrAccessListSuccess = (data = {}) => doResponseAction(QR_ACCESS_LIST_SUCCESS, data);
export const qrAccessListFailure = (data = {}) => doResponseAction(QR_ACCESS_LIST_FAILURE, data);
